import React, { useCallback, useState } from 'react'

import { Checkbox, Input, Select, SelectOption } from '../components'

const FONT_VALUES = [
  { value: 'Arial', label: 'Arial' },
  { value: 'Verdana', label: 'Verdana' },
]

interface InputProps {
  family: string
  size: string
  style: string
  weight: string
}

interface FontInputProps {
  value: InputProps
  onChange: (values: InputProps) => void
}

export function FontInput({ value, onChange }: FontInputProps) {
  const [family, setFamily] = useState(value.family)
  const [size, setSize] = useState(value.size)
  const [style, setStyle] = useState(value.style)
  const [weight, setWeight] = useState(value.weight)

  const setValue = useCallback(
    (key, valueSetter, value) => {
      valueSetter(value)
      onChange({ family, size, style, weight, [key]: value })
    },
    [family, size, style, weight, onChange]
  )

  return (
    <div>
      <div className="flex items-end space-x-2">
        <div>
          <Select
            label="Font"
            aria-label="Font"
            className="w-28"
            items={FONT_VALUES}
            value={FONT_VALUES.find((option) => option.value === value.family)?.value}
            onChange={(selected: { value: string }) => setValue('family', setFamily, selected.value)}
            data-testid="chart-modal-font-select"
          >
            {FONT_VALUES.map((option) => (
              <SelectOption key={option.value}>{option.label}</SelectOption>
            ))}
          </Select>
        </div>
        <Input
          label="Size"
          type="number"
          min="5"
          max="72"
          onChange={(ev: React.ChangeEvent<HTMLInputElement>) => setValue('size', setSize, ev.currentTarget.value)}
          value={size}
          data-testid="chart-modal-font-size"
        />

        <Checkbox
          checked={weight === 'bold'}
          onChange={(ev: React.ChangeEvent<HTMLInputElement>) =>
            setValue('weight', setWeight, ev.currentTarget.checked ? 'bold' : 'normal')
          }
          data-testid="chart-modal-font-weight"
        >
          Bold
        </Checkbox>
        <Checkbox
          checked={style === 'italic'}
          onChange={(ev: React.ChangeEvent<HTMLInputElement>) =>
            setValue('style', setStyle, ev.currentTarget.checked ? 'italic' : 'normal')
          }
          data-testid="chart-modal-font-style"
        >
          Italic
        </Checkbox>
      </div>
    </div>
  )
}
